// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylus/components/_data-iterator.styl
// module id = 136
// module chunks = 0